var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.59922 22.8031C2.93922 22.8031 2.37442 22.5683 1.90482 22.0987C1.43522 21.6291 1.20002 21.0639 1.19922 20.4031V3.60312C1.19922 2.94312 1.43442 2.37832 1.90482 1.90872C2.37522 1.43913 2.94002 1.20392 3.59922 1.20312H20.3992C21.0592 1.20312 21.6244 1.43833 22.0948 1.90872C22.5652 2.37912 22.8 2.94392 22.7992 3.60312V20.4031C22.7992 21.0631 22.5644 21.6283 22.0948 22.0987C21.6252 22.5691 21.06 22.8039 20.3992 22.8031H3.59922ZM4.79922 18.0031H19.1992L14.6992 12.0031L11.0992 16.8031L8.39922 13.2031L4.79922 18.0031Z",
    fill: "#2D3643"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage);
export default __webpack_public_path__ + "static/media/Image.21f69d079a6bc1df887d493a7032db09.svg";
export { ForwardRef as ReactComponent };